import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Stack, Divider } from '@mui/material';
import Iconify from '../../components/Iconify';
import { useManager } from '../Manager';
import { useStaff } from '../Staff';

export const NewDocumentAddedDialog = ({ open, setOpen, updateApplication, manager = false }) => {
  const { application } = manager ? useManager() : useStaff();
  console.log(application.new_document_added_by_office_descriptions);

  const handleClick = () => {
    updateApplication();
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={() => {}}>
      <DialogTitle>
        <Stack direction="row" alignItems="center" spacing={2} mb={2}>
          <Iconify icon="eva:info-fill" color="#007BFF" /> <Typography color="secondary">Alert</Typography>
        </Stack>
      </DialogTitle>

      <DialogContent>
        <Typography color="secondary" variant="body1" paragraph>
    Na twojej aplikacji pojawiły się nowe dokumenty. Przejrzyj zakładki z dokumentami i zapoznaj się z nimi.
          <br />
          <br />
    Lista nowych dokumentów:
        </Typography>

        {application.new_document_added_by_office_descriptions.map((item, key) => (
          <Stack key={key} spacing={2} sx={{ mb: 2 }} flexWrap={true}>
            <Typography variant="h6" color="primary" sx={{ fontWeight: 'bold' }}>
              Dokument #{key + 1}
            </Typography>
            <Stack spacing={1}>
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                Nazwa dokumentu:
              </Typography>
              <Typography variant="body2">{item.document_name}</Typography>

              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                Nazwa pliku:
              </Typography>
              <Typography variant="body2">{item.file_name}</Typography>

              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                Lokalizacja:
              </Typography>
              <Typography variant="body2"><u>{item.localization}</u></Typography>
            </Stack>

            {/* Optional Divider for a clear separation */}
            {key < application.new_document_added_by_office_descriptions.length - 1 && (
              <Divider sx={{ marginY: 2 }} />
            )}
          </Stack>
        ))}
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClick} variant="contained" color="secondary">
          Potwierdzam
        </Button>
      </DialogActions>
    </Dialog>
  );
};
